import styled from 'styled-components';

export const ContainerTitle = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 40px;
  color: #101828;
  font-family: 'Radio Canada';
  font-size: 40px;
  font-weight: 600;
  padding-top: 33px;
`;

export const SubTitle = styled.h3`
  color: #475467;
  font-family: 'Radio Canada';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 28px */
`;

export const ContainerStatus = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
`;

export const Status = styled.div`
  width: 100%;
  height: 100%;
`;
